import React from 'react';
import SelectionControlsGroupCore, {
  SelectionControlsGroupProps,
} from 'omakase/SelectionControls/SelectionControlsGroupCore';

/**
 * (Non-formik) Implementation of grouping behaviors for checkboxes.
 * Use Checkbox components as children.
 */
const CheckboxGroup: React.FunctionComponent<SelectionControlsGroupProps> = ({
  children,
  disabled,
  ...rest
}) => {
  return (
    <SelectionControlsGroupCore type="checkbox" {...rest}>
      {React.Children.map(children, (child) => {
        return React.cloneElement(child as React.ReactElement, { group: true, disabled });
      })}
    </SelectionControlsGroupCore>
  );
};

export default CheckboxGroup;
